import { AgGridVue } from 'ag-grid-vue';

export default {
  components: {
    AgGridVue,
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        suppressMovableColumns: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtrar',
        },
        enableCellTextSelection: true,
      },
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: true,
        resizable: true,
        suppressMenu: true,
        //editable: false,
      },
      rowClassRules: null,
      gridApi: null,
      gridColumnApi: null,
      selectedRows: null,
      searchQuery: '',
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();
      this.$emit('selectItem', this.selectedRows.length > 0 ? this.selectedRows[0] : null);
    },
  },
};
